export function getUnix() {
    return Date.now() / 1000;
}
export function delay(ms) {
    return new Promise((resolve) => {
        setTimeout(resolve, ms);
    });
}
export function unixToHourMinuteZulu(unix) {
    const date = new Date(unix * 1000);
    const hours = `${date.getUTCHours()}`.padStart(2, '0');
    const minutes = `${date.getUTCMinutes()}`.padStart(2, '0');
    return `${hours}h${minutes}Z`;
}
